import { FileType, ExtractionStatus } from './enums';

// 知識ベースに適した形式の制約
export const MATERIAL_CONSTRAINTS = {
  MAX_SIZE: 50 * 1024 * 1024, // 50MB
  MIN_SIZE: 1, // 1 byte
  ALLOWED_FORMATS: [
    'application/pdf',
    'text/plain',
    'text/markdown',
    'text/csv',
    'application/csv',
  ],
  ALLOWED_EXTENSIONS: [
    '.pdf',
    '.txt',
    '.md',
    '.csv',
  ],
  MAX_FILENAME_LENGTH: 255,
} as const;

export const MATERIAL_VALIDATION_MESSAGES = {
  FILE_SIZE_EXCEEDED: 'ファイルサイズは50MB以下にしてください',
  INVALID_FORMAT: 'サポートされていないファイル形式です（対応形式: PDF, テキスト, Markdown, CSV）',
  EMPTY_FILE: 'ファイルが空です',
  INVALID_NAME: 'ファイル名に無効な文字が含まれています',
} as const;

// File type icons
export const FILE_TYPE_ICONS = {
  [FileType.PDF]: '📄',
  [FileType.TXT]: '📝',
  [FileType.MD]: '📝',
  [FileType.CSV]: '📊',
} as const;

// File type colors for UI
export const FILE_TYPE_COLORS = {
  [FileType.PDF]: '#d32f2f',
  [FileType.TXT]: '#1976d2', 
  [FileType.MD]: '#1976d2',
  [FileType.CSV]: '#388e3c',
  [FileType.DOCX]: '#d32f2f',
  [FileType.DOC]: '#d32f2f',
  [FileType.PPTX]: '#ff9800',
  [FileType.PPT]: '#ff9800',
  [FileType.XLSX]: '#388e3c',
  [FileType.XLS]: '#388e3c',
  [FileType.HTML]: '#e65100',
} as const;

// File type display names
export const FILE_TYPE_NAMES = {
  [FileType.PDF]: 'PDF',
  [FileType.TXT]: 'テキスト',
  [FileType.MD]: 'Markdown',
  [FileType.CSV]: 'CSV',
  [FileType.DOCX]: 'Word文書',
  [FileType.DOC]: 'Word文書',
  [FileType.PPTX]: 'PowerPoint',
  [FileType.PPT]: 'PowerPoint',
  [FileType.XLSX]: 'Excel',
  [FileType.XLS]: 'Excel',
  [FileType.HTML]: 'HTML',
} as const;

// Status color mapping for UI
export const STATUS_COLORS = {
  [ExtractionStatus.PENDING]: 'warning',
  [ExtractionStatus.PROCESSING]: 'info',
  [ExtractionStatus.COMPLETED]: 'success',
  [ExtractionStatus.FAILED]: 'error',
} as const;

// Status labels in Japanese
export const STATUS_LABELS = {
  [ExtractionStatus.PENDING]: '待機中',
  [ExtractionStatus.PROCESSING]: '処理中',
  [ExtractionStatus.COMPLETED]: '完了',
  [ExtractionStatus.FAILED]: '失敗',
} as const;

// File type labels in Japanese (知識ベースサポート形式のみ)
export const FILE_TYPE_LABELS = {
  [FileType.PDF]: 'PDF',
  [FileType.TXT]: 'テキスト',
  [FileType.MD]: 'Markdown',
  [FileType.CSV]: 'CSV',
} as const;